import {Section} from '..';
import {Typography} from '@material-ui/core';
import {AutoField} from '../fields';
import {useFieldData} from '../hooks';
import {getInitialValues, getSchema} from 'components/forms/AutoSection';

const PreferredContactMethod = ({
    sectionName,
    sectionFields,
    existingData,
    fieldDict,
    ...props
}) => {
    const schema = getSchema(sectionFields, fieldDict);
    const initialValues = getInitialValues(
        existingData,
        sectionFields,
        fieldDict
    );

    const [deliverySameAsHome] = useFieldData(
        'applicant_delivery_same_as_home'
    );
    const [alternateNumber] = useFieldData('applicant_phone_alternate');

    const getOptions = () => {
        let options = ['Home Address'];
        if (!deliverySameAsHome) {
            options.push('Delivery Address');
        }
        options.push('Primary Phone Number');
        options.push('Email Address');
        if (alternateNumber) {
            options.push('Alternate Phone Number');
        }
        return options.map(option => {
            return {value: option, label: option};
        });
    };

    return (
        <Section {...props} schema={schema} initialValues={initialValues}>
            <Typography variant='h6' align='left'>
                {sectionName}
            </Typography>
            <AutoField
                field={fieldDict['applicant_prefered_contact_method']}
                name='applicant_prefered_contact_method'
                options={getOptions()}
            />
        </Section>
    );
};

export default PreferredContactMethod;
